import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleTreeView } from '@mui/x-tree-view';
import { useState } from 'react';
import { AlertErrors } from '../../../../ErrorHandling/ErrorBoundaryFallback';
import { ActionIcons } from '../../../../Iconography';
import { ObjectTreeLeaf } from './ObjectTreeLeafv2';
import { DefaultLabelClickWrapper } from './componentWrappers';
const debug = process.env.REACT_APP_DEBUG && false;
/** Accepts arbitrary TreeLeafs Sets up the root with required handling functions */
export const CurriedTreeRoot = ({ treeRootKey, children, expandedItems }) => {
    /** the ids MUI Tree uses to identify tree leaves. The state of the tree is controlled by this paor */
    const [expandedItemIds, setExpandedItemIds] = useState(expandedItems ?? []);
    debug && console.log('CurriedTreeRoot expandedItemIds', { expandedItemIds, expandedItems });
    return (_jsx(SimpleTreeView, { expandedItems: [...expandedItemIds], // this TreeView prop is an array of itemIds which are expanded,
        slots: { collapseIcon: ActionIcons.NavigationCollapse, expandIcon: ActionIcons.NavigationExpand },
        onSelectedItemsChange: (e) => {
            console.log('handle onSelectedItemsChange');
            e?.preventDefault();
            e?.stopPropagation();
        },
        onExpandedItemsChange: (event, itemIds) => {
            debug && console.log('handle onExpandedItemsChange', itemIds);
            setExpandedItemIds(itemIds);
        },
        onItemFocus: (e, itemId) => {
            debug && console.log('handle onItemFocus', { e, itemId });
            e?.preventDefault();
            e?.stopPropagation();
        },
        onFocusCapture: (e) => {
            debug && console.log('handle onFocusCapture', { e });
            e.preventDefault();
            e.stopPropagation();
        },
        onFocus: (e) => {
            debug && console.log('handle onFocus', { e });
            e.preventDefault();
            e.stopPropagation();
        },
        sx: { height: '100%', flexGrow: 1, maxWidth: '100%', overflowY: 'hidden', overflowX: 'hidden' },
        children }, treeRootKey));
};
/**
 * Renders a file system like tree of related nodes based on a definition in queryPaths, with the root nodes being in contextObjects
 * Accepts and uses nodeEdgeMapper as local store to allow dynamnic additions etc. This provided nodeEdgeMapper must be passed as same object on each render ( ie it should be a state variable useState<NodeEdgeMapper>(new NodeEdgeMapper()) in parent)
 * @param {number} maxVisibleNodes - Maximum amount of nodes to display before hiding the rest behind ellipses
 */
export const ObjectTree = ({ nodeEdgeMapper, contextObjects, queryPaths, suppressAPIQUery, onLabelClickWrapper: onLabelClickWrapperIn, onTypeFolderClickWrapper, hideTopStep, selectedNodeIds, setSelectedNodeIds, selectable, expandedItems, maxVisibleNodes, queryLimit, orderByName, itemDerivedControls, itemDerivedTreeFn, maintree_rightclick, uniqueTreeId, contextMenuComponentMap, }) => {
    const onLabelClickWrapper = onLabelClickWrapperIn ?? DefaultLabelClickWrapper;
    debug && console.log('ObjectTree v2 expandedNodeIds', { expandedItems });
    const apexNodes = contextObjects ?? nodeEdgeMapper.getApexNodes();
    debug && console.log('nodestates', { apexNodes, nemCount: nodeEdgeMapper.countNodes() });
    const treeRootKey = uniqueTreeId ?? `ObjectTree_${apexNodes.map((sourceNode) => sourceNode.id).join('')}.`;
    const children = apexNodes.map((apexNode) => {
        const ascendentAccessor = { ascendentAccessor: null, contextObject: apexNode };
        return (_jsx(ObjectTreeLeaf, { contextMenuComponentMap,
            nodeEdgeMapper,
            sourceObject: undefined,
            contextObject: apexNode,
            queryPaths,
            suppressAPIQUery,
            keyPrefix: `${treeRootKey}${apexNode.sk}`,
            onLabelClickWrapper,
            hideThisStep: hideTopStep,
            onTypeFolderClickWrapper,
            selectable,
            setSelectedNodeIds,
            selectedNodeIds,
            maxVisibleNodes,
            queryLimit,
            orderByName,
            itemDerivedControls,
            itemDerivedTreeFn,
            ascendentAccessor,
            maintree_rightclick }, `TreeLeaf_${apexNode.sk}`));
    });
    debug && console.log('Children of apex node', children);
    return _jsx(AlertErrors, { children: hideTopStep ? children : _jsx(CurriedTreeRoot, { treeRootKey, children, expandedItems }) });
};
